<template>
  <div>记录清除</div>
</template>

<script>
export default {

}
</script>

<style>

</style>